export default __webpack_public_path__ + "static/media/logo.dfb344b3.png";